<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Заказы</div>

      <div class="panel-body">

        <div class="loader" v-show="!loaded"></div>

        <div class="row" v-show="loaded">
          <div class="col-md-8">

          </div>
          <div class="col-md-4">
            <!--  -->
          </div>
        </div>

        <table class="table" v-show="loaded">
          <thead>
          <tr>
            <th>#</th>
            <th>Имя</th>
            <th>Телефон</th>
            <th>Дата</th>
            <th>Время</th>
            <th>Создан</th>
            <th class="text-right">Действие</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list">
            <td>{{item.id}}</td>
            <td>{{item.first_name + ' ' + item.last_name}}</td>
            <td>{{item.phone}}</td>
            <td>{{item.date}}</td>
            <td>{{item.time}}</td>
            <td>{{item.created_at}}</td>
            <td>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="edit(item)"><span
                  class="glyphicon glyphicon-edit"></span></button>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="del(item.id)"><span
                  class="glyphicon glyphicon-trash"></span></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-model="modalShow" :title="'Заказ #'+modalData.id" @hide="modalHide()" @before-close="beforeClose">

        <!--error-->
        <div class="alert alert-danger fade in" v-show="modalError">
          <p>{{modalError}}</p>
        </div>

        <!--form-->
        <form name="modal-form" id="modal-form">
          <div class="form-group">
            <label for="first_name" class="control-label">Имя:</label>
            <input class="form-control" id="first_name" v-model="modalData.first_name">
          </div>
          <div class="form-group">
            <label for="last_name" class="control-label">Фамилия:</label>
            <input class="form-control" id="last_name" v-model="modalData.last_name">
          </div>
          <div class="form-group">
            <label for="phone" class="control-label">Телефон:</label>
            <input class="form-control" id="phone" v-model="modalData.phone">
          </div>
          <div class="form-group">
            <label for="email" class="control-label">E-Mail:</label>
            <input class="form-control" id="email" v-model="modalData.email">
          </div>
          <div class="form-group">
            <label for="order_date" class="control-label">Предпочтительная дата доставки:</label>
            <input class="form-control" id="order_date" v-model="modalData.order_date" disabled>
          </div>
          <div class="form-group">
            <label for="order_time" class="control-label">Предпочтительное время доставки:</label>
            <input class="form-control" id="order_time" v-model="modalData.order_time" disabled>
          </div>
          <div class="form-group">
            <label for="metro" class="control-label">Метро:</label>
            <input class="form-control" id="metro" v-model="modalData.metro">
          </div>
          <div class="form-group">
            <label for="street" class="control-label">Улица:</label>
            <input class="form-control" id="street" v-model="modalData.street">
          </div>
          <div class="form-group">
            <label for="hourse" class="control-label">Дом:</label>
            <input class="form-control" id="hourse" v-model="modalData.hourse">
          </div>
          <div class="form-group">
            <label for="build" class="control-label">Строение:</label>
            <input class="form-control" id="build" v-model="modalData.build">
          </div>
          <div class="form-group">
            <label for="floor" class="control-label">Этаж:</label>
            <input class="form-control" id="floor" v-model="modalData.floor">
          </div>
          <div class="form-group">
            <label for="appartment" class="control-label">Кв./Оффис:</label>
            <input class="form-control" id="appartment" v-model="modalData.appartment">
          </div>
          <div class="form-group">
            <label for="intercom" class="control-label">Домофон:</label>
            <input class="form-control" id="intercom" v-model="modalData.intercom">
          </div>
        </form>

        <table class="table" style="margin-top: 35px;">
          <thead>
            <th>Товар</th>
            <th>Цена</th>
            <th>Кол-во</th>
            <th>Итого</th>
          </thead>
          <tbody>
            <tr v-for="item in modalData.details">
              <td>{{item.price.product.name}} ({{item.price.price_name}})</td>
              <td>{{formatPrice(item.cost)}}</td>
              <td>{{item.count}}</td>
              <td>{{formatPrice(item.total)}}</td>
            </tr>
          </tbody>
        </table>

        <strong>Итого:</strong> {{formatPrice(orderSum(modalData.details))}}

        <!-- footer -->
        <div slot="footer">
          <btn type="primary" class="pull-left" @click="store()">Сохранить</btn>
          <btn type="default" class="pull-left" @click="close()">Отмена</btn>
        </div>

    </modal>
  </div>
</template>

<script>
  import {api} from './http'

  export default {
    mounted () {
    },
    data () {
      return {
        modalShow: false,
        modalData: {categories_ids: []},
        modalError: '',
        categories: [],
        loaded: false,
        list: []
      }
    },
    beforeCreate () {
      this.loaded = false
      api.post('orders/list').then(response => {
        this.loaded = true
        this.list = response.data.items
        this.categories = response.data.categories
      })
    },
    methods: {
      formatPrice (value) {
        let val = (value / 1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ` `)
      },
      orderSum (details) {
        var sum = 0.0
        for (let key in details) {
          sum += parseFloat(details[key].total)
        }
        return sum
      },
      modalHide () {
        this.modalClose()
      },
      beforeClose () {
      },
      refreshList () {
        this.loaded = false
        api.post('orders/list').then(response => {
          this.loaded = true
          this.list = response.data.items
        })
      },
      add () {
        this.modalShow = true
      },
      edit (item) {
        var copyItem = {}
        Object.assign(copyItem, item)
        this.modalShow = true
        this.modalData = copyItem
      },
      close () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalClose () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      resetForm () {
        var form = document.querySelector('#modal-form')
        form.reset()
      },
      store () {
        var formData = new FormData()
        for (let key in this.modalData) {
          if (Array.isArray(this.modalData[key])) {
            for (let i in this.modalData[key]) {
              formData.append(key + '[]', this.modalData[key][i])
            }
          } else {
            let val = this.modalData[key] || ''
            formData.append(key, val)
          }
        }

        api.post('orders/storeorder', formData).then(response => {
          if (response.data.success) {
            this.modalClose()
            this.refreshList()
          } else {
            this.modalError = response.data.message
          }
        })
      },
      del (id) {
        api.post('orders/delete', {id: id})
          .then(() => this.refreshList())
      },
      resetModal () {
        this.modalData = {categories_ids: []}
      }
    }
  }
</script>

<style>
  .image-wrap {
/*    width: 370px;
    height: 248px;*/
    width: 100%;
    height: 67%;
    width: 568px;
    height: 380px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminOrders.vue